/**
 * Clears focus from the current element before a MUI Modal opens.
 * Prevents "Blocked aria-hidden on an element because its descendant retained focus"
 * when the trigger (e.g. mobile menu button) sits inside #root while the modal hides it.
 */
export function releaseFocusFromBackground(): void {
  const active = document.activeElement;
  if (active instanceof HTMLElement && active !== document.body) {
    active.blur();
  }
}
